export default __webpack_public_path__ + "static/tiles_top_desktop@2x-c21b3c7fbe789e8063feb8dbf8ba4369.png";